module.exports = __webpack_public_path__ + "static/media/acctiv_info.f41b794c.png";